import { createApp } from 'vue';
import ConsentMain from './ConsentMain.vue';

export const mount = () => {
  const consentAppDiv = document.getElementById('skagen-consent-app-page');
  if (consentAppDiv) {
    // This is a div on a page for updating the consent, usually on the privacy policy page
    // If the div is not found, the consent app is in a block view mode and not mounted on the skagen-consent-app-page div
    const consentInLineDiv = document.getElementById(
      'skagen-consent-app-inline'
    );
    const blockViewMode = consentInLineDiv ? true : false;
    const mountDivName = consentInLineDiv
      ? 'skagen-consent-app-inline'
      : 'skagen-consent-app-page';

    const app = createApp(ConsentMain, {
      blockViewMode,
    });

    app.mount('#' + mountDivName);
  }
};
